function fixNavbar(action) {
    var navbar = $('.navbar');

    $('.nav-menu').css('top', navbar.outerHeight());

    if (action === 'fix') {
        navbar.addClass('fixed');
    } else if (action === 'unfix') {
        navbar.removeClass('fixed');
    }
}

function accordionCalcs() {
    $('.accordion-line').removeClass('expanded').css('height', 'auto');

    $('.accordion-line').each(function () {
        var headHeight = $(this).find('.accordion-line-head').outerHeight(true);
        var bodyHeight = $(this).find('.accordion-line-body').outerHeight(true);
        $(this).css('height', headHeight).attr('data-all-height', headHeight + bodyHeight).attr('data-head-height', headHeight);
    });
}

function calculateLecturersLetters() {
    $('.lecturers-grid .lecturer').each(function (index) {
        var letter = $(this).data('letter');

        if ($(this).is(':visible')) {
            var waypoint = new Waypoint.Inview({
                element: this,
                enter: function (direction) {
                    $('.lecturers-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                entered: function (direction) {
                    $('.lecturers-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                exit: function (direction) {
                    $('.lecturers-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                },
                exited: function (direction) {
                    $('.lecturers-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                }
            })
        }
    });
}

function calculateScheduleWaypoints() {
    $('.sch-tab .days-wrap .days .day').each(function (ind, el) {
        var day = $(el).data('day');

        var waypoint = new Waypoint({
            element: this,
            handler: function (direction) {
                $('.sch-tab .days-wrap .days-mob .mobday').removeClass('active');
                $('.sch-tab .days-wrap .days-mob .mobday[data-day="' + day + '"]').addClass('active');
            },
            offset: '100px'
        })
    });
}

var w = 0;

$(document).ready(function () {


    if ($('.section-home-carousel').length > 0) {
        var homeSlider = $('.section-home-carousel .owl-carousel').owlCarousel({
            items: 1,
            nav: true,
            loop: true,
            mouseDrag: true,
            // mouseDrag: false
        });

        $('.carousel-slider').on('click', '.slide-nav .next', function () {
            $('.carousel-slider .owl-next').click();
        });
        $('.carousel-slider').on('click', '.slide-nav .prev', function () {
            $('.carousel-slider .owl-prev').click();
        });
    }

    w = $( window ).width();

    $('.sch-tab .days-wrap .days-mob .mobday').on('click', function () {
        var day = $(this).data('day');
        var to = $('.sch-tab .days-wrap .days .day[data-day=' + day + ']').offset().top;

        $("html, body").animate({scrollTop: to - 100});
    });

    var atarget = $('.nav-menu .container > ul.main-menu > li:not(".socials") > a');
    atarget.click(function (e) {
        e.preventDefault();

        if (($(this).next().hasClass('visible')) && ($(this).hasClass('rotate'))) {
            $(this).next().removeClass('visible');
            $(this).removeClass('rotate');
        } else {
            atarget.next().removeClass('visible');
            $(this).next().addClass('visible');
            atarget.removeClass('rotate');
            $(this).addClass('rotate');
        }
    });

    var galSlider = $('.modal-gallery .owl-carousel').owlCarousel({
        items: 1,
        autoWidth: true,
        margin: 50,
        nav: true,
        loop: true,
        mouseDrag: false
    });

    calculateLecturersLetters();

    calculateScheduleWaypoints();

    accordionCalcs();

    $('.accordion-line-head').on('click', function () {
        var el = $(this).parent();
        var headHeight = el.data('head-height');
        var allHeight = el.data('all-height');

        if (el.hasClass('expanded')) {
            el.removeClass('expanded');
            el.css('height', headHeight);
        } else {
            el.addClass('expanded');
            el.css('height', allHeight);
        }
    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $('.tab-trigger').on('mouseover', function () {
        var which = $(this).data('tab');

        if (!$(this).hasClass('active')) {
            $('.tab-trigger').removeClass('active');
            $(this).addClass('active');

            $('.tab').removeClass('active');

            setTimeout(function () {
                $('.tab').hide();
            }, 199);
            setTimeout(function () {
                $('.tab.' + which).show();
            }, 199);
            setTimeout(function () {
                $('.tab.' + which).addClass('active');
            }, 201);

        }
    });

    var openedTrustee = '';
    var trusteeCount = $('.modal-call-board.board-item').length;

    $('.next-trustee').on('click', function (e) {
        e.preventDefault();
        openedTrustee = openedTrustee + 1;

        console.log('.modal-call-board.board-item:nth-of-type(' + openedTrustee + ')');

        $('.modal-call-board.board-item:nth-of-type(' + openedTrustee + ')').click();
    });

    $('.modal-call-board.board-item').on('click', function (e) {
        e.preventDefault();
        var postId = $(this).data('id');
        var which = $(this).data('modal');
        var ind = openedTrustee = $(this).index() + 1;

        if (ind === trusteeCount) {
            $('.next-trustee').hide();
        } else {
            $('.next-trustee').show();
        }

        $.ajax({
            type: 'GET',
            url: '/wp-json/wp/v2/globeju_taryba/' + postId,
            success: function (response) {
                e.preventDefault();

                $('.modal-' + which).find('p').remove();

                $('.modal-trustee img').attr('src', response.acf.photo);
                $('.modal-trustee h2').html(response.acf.name_surname);
                $('.modal-trustee h5').html(response.acf.caption_under_name);
                $('.modal-trustee .right .text').append(response.acf.text);

                $('.modal-' + which).addClass('active');
                $('body').addClass('fixed');
            }
        });
    });

    $('.close-trustee').on('click', function (e) {
        e.preventDefault();
        $('.modal').removeClass('active');
        $('body').removeClass('fixed');
    });

    $('.modal-call-career').on('click', function (e) {
        e.preventDefault();
        var postId = $(this).data('id');
        var which = $(this).data('modal');

        var posttype = 'karjera';

        if ($(this).hasClass('mobility-programs')) {
            posttype = 'mobilumo_programos';
        }
        if ($(this).hasClass('student-practice')) {
            posttype = 'studentu_praktikos';
        }

        $.ajax({
            type: 'GET',
            url: '/wp-json/wp/v2/' + posttype + '/' + postId,
            success: function (response) {
                e.preventDefault();

                $('.left-right .left').remove();
                $('.career-info-wrap').remove();
                $('.modal-career .right .wysiwyg').html('');
                $('.modal-career .right .download-documents > a').remove();
                $('.modal-career .right .download-documents').hide();
                $('.modal-career .right > a').remove();

                if (response.acf.photo) {
                    $('.left-right').prepend('<div class="left"><img src="' + response.acf.photo + '"></div>');
                }

                $('.modal-career h2').html(response.title.rendered);

                if (response.acf.info_blocks) {
                    $('.modal-career .right').append('<div class="career-info-wrap"></div>');
                    $.each(response.acf.info_blocks, function (key, val) {
                        $('.modal-career .right').find('.career-info-wrap').append('<div class="career-info"><h6>' + val.title + '</h6><p>' + val.text + '</p></div>')
                    })
                }

                $('.modal-career .right .wysiwyg').append(response.acf.text);

                if (response.acf.document_downloads) {
                    $('.modal-career .right .download-documents').show();
                    $.each(response.acf.document_downloads, function (key, val) {
                        var url = val.link;
                        if (val.file_or_link === 'file') {
                            url = val.file;
                        }
                        $('.modal-career .right .download-documents').append('<a href="' + url + '" class="arrow-link arrow-down" target="_blank"><span>' + val.document_name + '</span></a>');
                    })
                }

                if (response.acf.link) {
                    $('.modal-career .right').append('<a href="' + response.acf.link + '" target="_blank" class="arrow-link">' + response.acf.link_text + '</a>');
                }

                $('.modal-' + which).addClass('active');
                $('body').addClass('fixed');
            }
        });
    });

    $(window).keydown(function (event) {
        if (event.keyCode === 27) {
            $('.modal').removeClass('active');
            $('body').removeClass('fixed');
        }

        if (event.keyCode === 37) {
            if ($('.modal-gallery').hasClass('active')) {
                $('.modal-gallery .owl-prev').click();
            }
        }
        if (event.keyCode === 39) {
            if ($('.modal-gallery').hasClass('active')) {
                $('.modal-gallery .owl-next').click();
            }
        }
    });

    $('.modal-call').on('click', function (e) {
        e.preventDefault();
        var which = $(this).data('modal');

        $('.modal-' + which).addClass('active');
        $('body').addClass('fixed');

        if (which === 'gallery') {
            var index = $(this).index();
            galSlider.trigger('to.owl.carousel', [index, 0]);
        }
    });

    $('.modal, .modal-close, .modal-content-wrap').on('click', function (e) {
        if (e.target === this) {
            $('.modal').removeClass('active');
            $('body').removeClass('fixed');
        }
    });

    $('.section-subscribe select').select2({
        minimumResultsForSearch: Infinity
    });

    var lectSche = $('.section-schedules-lecturers select').select2({});

    lectSche.on("select2:select", function (e) {
        var which = e.params.data.id;
        var url = $('.section-schedules-lecturers .selection').data('link');
        url = url.replace('tochange', which);

        $('.section-schedules-lecturers .submit .arrow-link').attr('href', url);
    });

    $('body').on('click', '.to-trig', function () {
        $(this).parent().parent().toggleClass('active');

        $('input[name=usertype]').val('');
        var data = $('#forma').serialize();

        $.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: data,
            success: function (response) {
                if ($('.user-type-selection li').hasClass('active')) {
                    window.location.reload()
                }
            }
        });
    });

    $('.user-type-selection li').on('click', function () {
        var type = $(this).data('type');

        $('#forma input[name=usertype]').val(type);
        var data = $('#forma').serialize();

        $.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: data,
            success: function (response) {
                window.location.reload()
            }
        });
    });

    // Notifications

    var notifarray = [];
    // $('.user-notif').each(function (ind, el) {
    //     if ($(el).data('count') === 'once') {
    //         $(el).addClass('inactive');
    //     }
    // });

    if(sessionStorage.getItem('notifarray')) {
        var arr = sessionStorage.getItem('notifarray').split(',');
        arr.forEach(function (ind) {
            $('.user-notif[data-pid=' + ind + ']').addClass('inactive');
        });
    }

    $('.user-notifications').addClass('active');

    $('.user-notif .close').on('click', function () {
        var pid = $(this).parent().data('pid');
        if ($(this).parent().data('count') === 'once') {
            notifarray.push(pid);
            sessionStorage.setItem('notifarray', notifarray);
        }

        $(this).parent().hide();
    });

    // Schedule group select

    var scheduleSelect = $('.sch-tabs select').select2({
        minimumResultsForSearch: Infinity
    });
    if ($('.lectfilt').length > 0) {
        scheduleSelect = $('.sch-tabs select').select2({

        });
    }
    scheduleSelect.on("select2:select", function (e) {
        var which = e.params.data.id;
        var url = $('.filter-wrap').data('link');

        url = url.replace('tochange', which);

        window.location = url;
    });

    // $('.sch-tab-trigger').on('click', function () {
    //     var year = $(this).data('year');
    //
    //     $('.sch-tab-trigger').removeClass('active');
    //     $(this).addClass('active');
    //     $('.sch-tab').removeClass('active');
    //     $('.sch-tab[data-year=' + year + ']').addClass('active');
    // });

    if ($('.caption-content').length > 0) {
        $('.caption-content').each(function (ind, el) {
            var height = $(this).outerHeight();
            var fsize = ((height / (-20)) + 60).toFixed(0);

            if (fsize < 24) {
                fsize = 24;
            } else if (fsize > 40) {
                fsize = 40;
            }

            if (fsize < 30) {
                $(this).css('font-weight', '600');
            }

            $(this).css('font-size', fsize + 'px');
            $(this).css('line-height', (+fsize+10) + 'px');
        })
    }

    if ($('.page-template-page-projects-and-research').length > 0) {
        $('.page-template-page-projects-and-research .single-news.no-image h3').each(function (ind, el) {
            var height = $(this).outerHeight();
            var fsize = ((height / (-15)) + 60).toFixed(0);

            if (fsize < 24) {
                fsize = 24;
            } else if (fsize > 40) {
                fsize = 40;
            }

            if (fsize < 30) {
                $(this).css('font-weight', '600');
            }

            $(this).css('font-size', fsize + 'px');
            $(this).css('line-height', (+fsize+10) + 'px');
        })
    }

    if ($('.single-publication').length > 0) {
        var height = $('.single-publication h1').outerHeight();
        var fsize = ((height / (-20)) + 80).toFixed(0);

        if (fsize < 40) {
            fsize = 40;
        } else if (fsize > 80) {
            fsize = 80;
        }

        $('.single-publication h1').css('font-size', fsize + 'px');
        $('.single-publication h1').css('line-height', (+fsize+10) + 'px');
    }

    var depSelect = $('.lecturers-hero select').select2({
        minimumResultsForSearch: Infinity
    });
    depSelect.on("select2:select", function (e) {
        var which = e.params.data.id;
        if (which === 'all') {
            $('.lecturers-grid .lecturer').show();
            $('.lecturers-letters .letter').removeClass('active');
            Waypoint.destroyAll();
            calculateLecturersLetters();
            console.log('all')
        } else {
            $('.lecturers-grid .lecturer').show();
            $('.lecturers-grid .lecturer:not(.' + which + ')').hide();
            $('.lecturers-letters .letter').removeClass('active');
            Waypoint.destroyAll();
            calculateLecturersLetters();
            console.log(which)
        }
    });

    var areaSelect = $('.career-hero select').select2({
        minimumResultsForSearch: Infinity
    });
    areaSelect.on("select2:select", function (e) {
        var which = e.params.data.id;
        if (which === 'all') {
            $('.section-student-career .single-news').show();
            $('.publications-grid .publication').show();
        } else {
            $('.section-student-career .single-news').show();
            $('.section-student-career .single-news:not(.' + which + ')').hide();
            $('.publications-grid .publication').show();
            $('.publications-grid .publication:not(.' + which + ')').hide();
        }
    });


    var filter1val = '';
    var filter2val = '';
    var projectfilter1 = $('.projects-hero select:nth-of-type(1)').select2({
        minimumResultsForSearch: Infinity
    });
    var projectfilter2 = $('.projects-hero select:nth-of-type(2)').select2({
        minimumResultsForSearch: Infinity
    });
    projectfilter1.on("select2:select", function (e) {
        var which = e.params.data.id;
        if (which === 'all') {
            filter1val = '';
        } else {
            filter1val = which;
        }
        filterProjects();
    });
    projectfilter2.on("select2:select", function (e) {
        var which = e.params.data.id;
        if (which === 'all') {
            filter2val = '';
        } else {
            filter2val = which;
        }
        filterProjects();
    });
    function filterProjects() {
        var addup = '';
        if (filter1val && filter2val) {
            addup = '.' + filter1val + '.' + filter2val;
        } else if (filter1val && !filter2val) {
            addup = '.' + filter1val;
        } else if (!filter1val && filter2val) {
            addup = '.' + filter2val;
        }
        $('.section-student-career .single-news').show();
        if (addup) {
            $('.section-student-career .single-news:not(' + addup + ')').hide();
        }
    }

    $('.lecturers-letters .letter').on('click', function () {
        var letter = $(this).data('letter');
        var to = $('.lecturers-grid .lecturer[data-letter=' + letter + ']').offset().top;

        $("html, body").animate({scrollTop: to - 100});
    });

    $('.subscribe-email').on('change paste input', function () {
        if ($('.subscribe-email').val().length > 0) {
            $('.subscribe-submit').addClass('active');
        } else {
            $('.subscribe-submit').removeClass('active');
        }
    });

    $('.subscribe-submit').on('click', function (e) {
        e.preventDefault();

        $('.input-wrap').removeClass('invalid');

        if (!validateEmail($('.subscribe-email').val())) {
            $(this).parent().addClass('invalid');
        }

        if (!$('.input-wrap').hasClass('invalid')) {
            $('.hidden-submit').click();
            //$('.section-subscribe-success').addClass('active');
        }
    });

    $('.deps-tab-trigger').on('click', function () {
        var tab = $(this).data('tab');

        $('.deps-tab-trigger').removeClass('active');
        $(this).addClass('active');
        $('.deps-tab').removeClass('active');
        $('.deps-tab[data-tab=' + tab + ']').addClass('active');
    });

    $('.lecturer-pursuit-block .link').on('click', function () {
        $('.lecturer-pursuit-block p').show();
        $(this).hide();
    });

    var eq = true;

    function checkEqual(el) {
        eq = true;

        $('.nav-menu *').each(function (ind, elem) {
            if (el === $(elem)[0]) {
                eq = false;
            }
        })

        return eq;
    }

    $('body').on('click', function (e) {
        if ($('body').hasClass('nav-menu-active')) {
            var trgt = $(e.target)[0];
            checkEqual(trgt);
            if ((trgt !== $('.menu-trigger')[0]) && (trgt !== $('.nav-menu')[0]) && eq) {
                $('body').removeClass('nav-menu-active');
            }
        }
    });

    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('nav-menu-active');
    });

    if ($(window).scrollTop() > 60) {
        fixNavbar('fix')
    } else {
        fixNavbar('unfix')
    }

    $('.lecturers-letters').stick_in_parent({offset_top: 19});
    $('.days-mob').stick_in_parent({offset_top: 100});

    $('.single-news-socials .social.facebook').on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');

        FB.ui({
            method: 'share',
            href: window.location.href
        }, function(response){});
    });

    $('.single-news-socials .social.linkedin').on('click', function (e) {
        e.preventDefault();

        // shareContent();
    });

    if ($('.section-about-deps').length > 0) {
        $('.deps-tab[data-tab=2]').removeClass('active');
    }

    $('#pasirenk').on('click', function () {
        $('.line.pasirenkamas').toggle();
        $('.nolect').toggle();
    });
    $('.days .day').each(function (ind, el) {
        var yrapaskaitu = false;
        var yrapasirenkamu = false;

        if ($(el).find('.table-body .line').length > 0) {

            $(el).find('.table-body .line').each(function (ind, el) {
                if ($(el).hasClass('pasirenkamas')) {
                    yrapasirenkamu = true;
                } else {
                    yrapaskaitu = true;
                }
            });

            if (yrapaskaitu) {
                $(el).find('.nolect').addClass('hard');
            }

        } else {
            $(el).find('.nolect').addClass('hard');
        }
    });

    $('.user-type-selection-notif .close').on('click', function () {
        $(this).parent().toggleClass('smaller');
    });

    $('.user-type-selection-notif li').on('click', function () {
        var type = $(this).data('type');

        if ($(this).hasClass('active')) {
            $('#formadesk input[name=usertype]').val('');
        } else {
            $('#formadesk input[name=usertype]').val(type);
        }
        var data = $('#formadesk').serialize();

        $.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: data,
            success: function (response) {
                window.location.reload()
            }
        });
    });

    $('#searchform input[type=text]').attr('placeholder', $('.search-wrapper').data('placeholder'));

    $('.search-wrapper .close span').on('click', function () {
        $('.search-wrapper').removeClass('active');
        $('body').addClass('srcinactive');
        $('body').removeClass('fixed');
    });
    $('.search-trigger').on('click', function () {
        $('.search-wrapper').addClass('active');
        $('body').addClass('fixed');
        setTimeout(function () {
            $('body').removeClass('srcinactive');
        }, 400);
    });
});

$(window).on('scroll', function () {

    if ($(this).scrollTop() > 0) {
        $('.user-type-selection-notif').addClass('smaller');
    } else {
        if (!$('.user-type-selection-notif li').hasClass('active')) {
            $('.user-type-selection-notif').removeClass('smaller');
        }
    }

    if ($(window).width() > 1270) {
        if ($(this).scrollTop() > 60) {
            fixNavbar('fix')
        } else {
            fixNavbar('unfix')
        }
    } else if (($(window).width() < 1270) && ($(window).width() > 690)) {
        if ($(this).scrollTop() > 20) {
            fixNavbar('fix')
        } else {
            fixNavbar('unfix')
        }
    } else if (($(window).width() < 690)) {
        if ($(this).scrollTop() > 20) {
            fixNavbar('fix')
        } else {
            fixNavbar('unfix')
        }
    }
});

$(window).on('resize', function () {
    if (w !== $(window).width()) {
        accordionCalcs();
        calculateLecturersLetters();
        w = $(window).width();
    }
});
